const PayrollDashboard = () => import('@/components/payroll/Dashboard.vue')
const PayrollConfronta = () => import('@/components/payroll/Confronta.vue')
const PayrollNotStampedInvoices = () => import('@/components/payroll/NotStampedInvoices.vue')
const PayrollAdjustments = () => import('@/components/payroll/Adjustments.vue')
const PayrollInvoices = () => import('@/components/payroll/Invoices.vue')

const payrollPermissions = [
  'dashboard_nomina',
  'confronta_nomina',
  'no_timbrados',
  'poliza_ajuste',
  'cfdis_descargados_nomina'
]

export const payrollRoutes = [
  {
    path: '/payroll',
    meta: { breadcrumb: 'Nómina', requiresAuth: true, permissions: payrollPermissions },
    children: [
      { path: 'dashboard', component: PayrollDashboard, meta: { breadcrumb: 'Dashboard', permissions: [payrollPermissions[0]] } },
      { path: 'confronta', component: PayrollConfronta, meta: { breadcrumb: 'Confronta', permissions: [payrollPermissions[1]] } },
      { path: 'not-stamped-invoices', component: PayrollNotStampedInvoices, meta: { breadcrumb: 'No Timbrados', permissions: [payrollPermissions[2]] } },
      { path: 'adjustments', component: PayrollAdjustments, meta: { breadcrumb: 'Pólizas de Ajuste', permissions: [payrollPermissions[3]] } },
      { path: 'invoices', component: PayrollInvoices, meta: { breadcrumb: 'CFDIs', permissions: [payrollPermissions[4]] } },
    ],
  },
]
